import { useContext } from '@builder.io/qwik';
import { ArticleContext } from '~/contexts/ArticleContext';
import type { MMContentEmbedBlockInterface } from '~/types/AppData/Blocks/MMContentEmbedBlockInterface';

export function useRecircWidget(placement?: string) {
  if (placement !== 'article-bottom') {
    return true;
  }

  const article = useContext(ArticleContext);

  if (!article) return false;

  const lastThreeBlocks = article.body?.slice(-3) ?? [];

  // Check if any of the last 3 blocks is a GroupOfLinks embed
  const hasGroupOfLinks = lastThreeBlocks.filter((block) => {
    if (block.type === 'mm-content-embed') {
      const embedBlock = block as MMContentEmbedBlockInterface;
      return embedBlock.value.embedType === 'GroupOfLinks';
    }
    return false;
  });

  return hasGroupOfLinks.length === 0;
}
